import React from "react";
import './Home.css';

function Home() {
 return (
      <div className="home-container">
      <header className="home-content">
          <h1>Welcome to LLMaaS Operations Portal!</h1>
        </header>
      </div>
    )
  }
  
  export default Home;
